import { Link } from 'react-router-dom';

export default function CertBadges() {
  return (
    <section className="bg-white border-b border-gray-100 py-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          {/* ISO Certs */}
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="flex items-center gap-3 bg-teal-50 border border-teal-200 rounded-xl px-5 py-3">
              <div className="w-9 h-9 flex items-center justify-center bg-teal-600 text-white rounded-lg flex-shrink-0">
                <i className="ri-award-fill text-lg" />
              </div>
              <div>
                <div className="text-xs text-teal-600 font-semibold">ISO Certified</div>
                <div className="text-sm font-bold text-gray-900">9001:2015</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-teal-50 border border-teal-200 rounded-xl px-5 py-3">
              <div className="w-9 h-9 flex items-center justify-center bg-teal-600 text-white rounded-lg flex-shrink-0">
                <i className="ri-shield-check-fill text-lg" />
              </div>
              <div>
                <div className="text-xs text-teal-600 font-semibold">ISO/IEC Certified</div>
                <div className="text-sm font-bold text-gray-900">27001:2022</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-teal-50 border border-teal-200 rounded-xl px-5 py-3">
              <div className="w-9 h-9 flex items-center justify-center bg-teal-600 text-white rounded-lg flex-shrink-0">
                <i className="ri-time-fill text-lg" />
              </div>
              <div>
                <div className="text-xs text-teal-600 font-semibold">Since 1999</div>
                <div className="text-sm font-bold text-gray-900">25+ Years</div>
              </div>
            </div>
            <Link
              to="/about"
              className="cursor-pointer whitespace-nowrap flex items-center gap-2 text-teal-600 hover:text-teal-700 font-semibold text-sm"
            >
              Learn About Us <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
